import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';

const ReviewTable = () => {
  const { isSidebarOpen } = useSidebar();

  const [searchQuery, setSearchQuery] = useState('');
  const [reviews, setReviews] = useState([]);

  const [filteredReviews, setFilteredReviews] = useState(reviews);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading]=useState(true)
  const itemsPerPage = 6;


        const BASE_URL = process.env.REACT_APP_API_BASE_URL;


    useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/reviews`); // Adjust URL if needed
        const data = await res.json();
        setReviews(data);
        setFilteredReviews(data);
      } catch (err) {
        console.error('Error fetching reviews:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, []);

  useEffect(() => {
    const filtered = reviews.filter((review) =>
      Object.values(review).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
    setFilteredReviews(filtered);
    setCurrentPage(1);
  }, [searchQuery, reviews]);

  const totalPages = Math.ceil(filteredReviews.length / itemsPerPage);
  const currentData = filteredReviews.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleSearch = (e) => setSearchQuery(e.target.value);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <Header />
      <Sidebar />
      <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
        <h1 className="dashboard-title">Room Reviews</h1>

        <div className="filter-search">
          <div className="filter-search-input">
            <input
              type="search"
              placeholder="Search by name, title, date or rating..."
              value={searchQuery}
              onChange={handleSearch}
            />
            <i className="fa fa-search"></i>
          </div>
        </div>

        <div className="customer-table">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Review Title</th>
                <th>Date</th>
                <th>Rating</th>
              </tr>
            </thead>
            <tbody>
              {currentData.length > 0 ? (
                currentData.map((review, index) => (
                  <tr key={index}>
                    <td>{review.name}</td>
                    <td>{review.title}</td>
                    <td>{review.date}</td>
                    <td>{review.rating} ★</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center' }}>
                    No reviews found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <i className="fa-solid fa-chevron-left"></i>
            <i className="fa-solid fa-chevron-left"></i>
          </button>

          <button className="active">{currentPage}</button>

          {currentPage < totalPages && (
            <button onClick={() => paginate(currentPage + 1)}>
              {currentPage + 1}
            </button>
          )}

          {currentPage + 1 < totalPages && <span className="dots">...</span>}

          {currentPage !== totalPages && (
            <button onClick={() => paginate(totalPages)}>{totalPages}</button>
          )}

          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <i className="fa-solid fa-chevron-right"></i>
            <i className="fa-solid fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </>
  );
};

export default ReviewTable;
